import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// Internal imports
import Button from 'components/common/button'
import Register from 'components/register'
import SignInWithRewards from 'components/signIn/SignInRewards'
import { LanguageContext } from 'context/LanguageContext'
import { LayoutContext } from 'context/LayoutContext'
import EnterOtp from './EnterOtp'
import { mfaAuthFailed, otpGenerateSuccess } from 'modules/authentication/actions'
import { otpGenerateSuccess as otpGenerateSuccessRegister, resetUser } from 'modules/user/actions'

const SignInOptions = props => {
    const { strings } = useContext(LanguageContext)
    const dispatch = useDispatch()

    const { closePanel, panelOpen } = useContext(LayoutContext)
    const socialAuthEnabled = useSelector(state => state.configuration.get('social_login'))
    const loginProcessIsOn = useSelector(state => state.authentication.get('loggingIn'))
    const loggingInWithFacebook = useSelector(state =>
        state.authentication.get('loggingInWithFacebook')
    )
    const [userData, setUserData] = useState({
        username: '',
        password: '',
    })
    const [state_loggingInWithFacebook, setLoginWithFB] = useState(loggingInWithFacebook)
    const userProfile = useSelector(state => state.user.getIn(['userProfile']))
    const [showRegister, setShowRegister] = useState(false)
    const valueRef = useRef(false)
    const showOTPScreen = useSelector(state => state.authentication.getIn(['showOTPScreen']))
    const otpData = useSelector(state => state.authentication.getIn(['otpData']))

    useEffect(() => {
        setLoginWithFB(loggingInWithFacebook)
        if (userProfile !== null && panelOpen) {
            closePanel()
        }
    }, [loggingInWithFacebook, userProfile])

    const onRegisterClicked = () => {
        valueRef.current = true
        setShowRegister(true)
        dispatch(otpGenerateSuccessRegister(false))
    }

    useEffect(() => {
        dispatch(otpGenerateSuccess(false))
        dispatch(otpGenerateSuccessRegister(false))
        dispatch(mfaAuthFailed(null))
        dispatch(resetUser())
    }, [])

    if (showOTPScreen) {
        return <EnterOtp otpData={otpData} signInFromBasket={props.signInFromBasket} />
    }
    return (
        <>
            {!showRegister ? (
                <div className="form">
                    <>
                        <SignInWithRewards
                            nextStep={props.nextStep}
                            hide={props.hide}
                            signInFromBasket={props.signInFromBasket}
                            valueRef={valueRef}
                        />
                    </>
                    {!loginProcessIsOn ? (
                        <div className="form__register">
                            <p>{strings.noAccount}</p>
                            <button className="noBdyButton" onClick={onRegisterClicked}>
                                {strings.registerButton}
                            </button>
                        </div>
                    ) : null}
                </div>
            ) : (
                <Register
                    hide={props.hide}
                    show={props.show}
                    setShowRegister={setShowRegister}
                    signInFromBasket={props.signInFromBasket}
                />
            )}
        </>
    )
}

export default SignInOptions
